import { formatUnit } from '../../utils/units';

export type CommercialPriceSide = 'sale' | 'purchase';

export interface CommercialPriceUnitInput {
  unit?: string | null;
  saleUnit?: string | null;
  purchaseUnit?: string | null;
}

export function getCommercialPriceUnit(
  side: CommercialPriceSide,
  line: CommercialPriceUnitInput | null | undefined,
): string {
  const commercialUnit = side === 'sale' ? line?.saleUnit : line?.purchaseUnit;
  return commercialUnit || line?.unit || 'pcs';
}

export function formatCommercialPriceUnit(
  side: CommercialPriceSide,
  line: CommercialPriceUnitInput | null | undefined,
  language?: string,
): string {
  return formatUnit(getCommercialPriceUnit(side, line), language);
}
